export interface ShopifyCart {
  id: number;
  handle: string;
  url: string;
  title: string;
  quantity: number;
  [key: string]: any;
}
